/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import HeroSectionv2 from './HeroSectionv2';
import Featuresv2 from './Featuresv2';
import FeatureCards from './FeatureCards';
import IndustryTestimonialPage from './Testimonialsv2';
import CTASection from './CTASection';
import FooterSection from './FooterSection';
import PricingSection from './PricingSection';

const PageWrapper = styled.div`
  min-height: 100vh;
  background-color: white;
`;

export default function LandingPage() {
  return (
    <PageWrapper className="font-inter font-normal">
      <HeroSectionv2 />
      <Featuresv2 />
      <FeatureCards />
      <PricingSection/>
      <IndustryTestimonialPage />
      <CTASection />
      <FooterSection />
    </PageWrapper>
  );
}
